import { z } from 'zod';
/** A scoping filter, present or absent: an empty list would scope the search to nothing. */
const ManualJobScopeIdsSchema = z.array(z.uuid()).min(1);
/**
 * The part of a manual job search primary reads. Orchestrator runs the search and owns every other
 * filter, so anything else in the body is passed along untouched; practice groups and organizations
 * are here because only primary knows how to resolve them down to practices.
 */
export const ManualJobFindAllBodySchema = z.looseObject({
    practiceIds: ManualJobScopeIdsSchema.optional(),
    practiceGroupIds: ManualJobScopeIdsSchema.optional(),
    organizationIds: ManualJobScopeIdsSchema.optional(),
});
//# sourceMappingURL=findAll.js.map